const ENDPOINT = process.env.REACT_APP_ENDPOINT;
const incrementQScore = async (id, type, puzzleId) => {
    const apiUrl = `${ENDPOINT}/select/?media_or_actor_id=${id}&media_or_actor=${type.toLowerCase()}&puzzle_id=${puzzleId}`;
    try {
        const response = await fetch(apiUrl,
            {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
            }
        );
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating game:', error);
    }
}

export default incrementQScore;